import apiClient from '../server';

// Search events using Meilisearch
export const searchEventsMeili = async (query = '', filters = {}) => {
  try {
    // Build query parameters
    const params = new URLSearchParams();
    
    if (query) params.append('q', query);
    if (filters.musicTypes) params.append('musicTypes', filters.musicTypes);
    if (filters.city) params.append('city', filters.city);
    if (filters.country) params.append('country', filters.country);
    if (filters.eventType) params.append('eventType', filters.eventType);
    if (filters.isFeatured !== undefined) params.append('isFeatured', filters.isFeatured);
    if (filters.isPublished !== undefined) params.append('isPublished', filters.isPublished);
    if (filters.startDateFrom) params.append('startDateFrom', filters.startDateFrom);
    if (filters.startDateTo) params.append('startDateTo', filters.startDateTo);
    if (filters.limit) params.append('limit', filters.limit);
    if (filters.offset) params.append('offset', filters.offset);

    console.log('🔍 [MeiliSearch] Searching events with URL:', `/meilisearch/search/events?${params.toString()}`);
    
    const response = await apiClient.get(`/meilisearch/search/events?${params.toString()}`);
    console.log('🔍 [MeiliSearch] Events response:', response.data);
    
    return {
      data: response.data.hits || [],
      total: response.data.estimatedTotalHits || 0,
      processingTime: response.data.processingTimeMs || 0
    };
  } catch (error) {
    console.error('🔍 [MeiliSearch] Error searching events:', error);
    if (error.response) {
      console.error('🔍 [MeiliSearch] Error response data:', error.response.data);
      console.error('🔍 [MeiliSearch] Error response status:', error.response.status);
    }
    throw error;
  }
};

// Search tracks using Meilisearch
export const searchTracksMeili = async (query = '', filters = {}) => {
  try {
    // Build query parameters
    const params = new URLSearchParams();
    
    if (query) params.append('q', query);
    if (filters.musicTypes) params.append('musicTypes', filters.musicTypes);
    if (filters.city) params.append('city', filters.city);
    if (filters.country) params.append('country', filters.country);
    if (filters.genre) params.append('genre', filters.genre);
    if (filters.isHidden !== undefined) params.append('isHidden', filters.isHidden);
    if (filters.isExplicit !== undefined) params.append('isExplicit', filters.isExplicit);
    if (filters.limit) params.append('limit', filters.limit);
    if (filters.offset) params.append('offset', filters.offset);

    console.log('🔍 [MeiliSearch] Searching tracks with URL:', `/meilisearch/search/tracks?${params.toString()}`);
    
    const response = await apiClient.get(`/meilisearch/search/tracks?${params.toString()}`);
    console.log('🔍 [MeiliSearch] Tracks response:', response.data);
    
    return {
      data: response.data.hits || [],
      total: response.data.estimatedTotalHits || 0,
      processingTime: response.data.processingTimeMs || 0
    };
  } catch (error) {
    console.error('🔍 [MeiliSearch] Error searching tracks:', error);
    if (error.response) {
      console.error('🔍 [MeiliSearch] Error response data:', error.response.data);
      console.error('🔍 [MeiliSearch] Error response status:', error.response.status);
    }
    throw error;
  }
};

// Search both events and tracks using Meilisearch
export const searchPublicationsMeili = async (query = '', filters = {}) => {
  try {
    // Build query parameters for multi-index search
    const params = new URLSearchParams();
    
    if (query) params.append('q', query);
    if (filters.musicTypes) params.append('musicTypes', filters.musicTypes);
    if (filters.city) params.append('city', filters.city);
    if (filters.country) params.append('country', filters.country);
    if (filters.limit) params.append('limit', filters.limit);
    if (filters.offset) params.append('offset', filters.offset);

    console.log('🔍 [MeiliSearch] Searching publications with URL:', `/meilisearch/search/multi?${params.toString()}&indices=events,tracks`);
    
    const response = await apiClient.get(`/meilisearch/search/multi?${params.toString()}&indices=events,tracks`);
    console.log('🔍 [MeiliSearch] Publications response:', response.data);
    
    return {
      results: response.data.results || {},
      total: response.data.totalHits || 0,
      processingTime: response.data.processingTimeMs || 0
    };
  } catch (error) {
    console.error('🔍 [MeiliSearch] Error searching publications:', error);
    if (error.response) {
      console.error('🔍 [MeiliSearch] Error response data:', error.response.data);
      console.error('🔍 [MeiliSearch] Error response status:', error.response.status);
    }
    throw error;
  }
}; 